module.exports = __webpack_public_path__ + "img/activities-10.28aa4621.jpg";